import type { ReportAnswers } from '../../../../report/CustomerReport';
import { isAnswerValueSelected } from '../../../../report/getQuestion';
import { ProblemTypeQuestionValue } from '../../../../report/questions/problemType/ProblemTypeQuestion';
import { ReportQuestion } from '../../../../report/questions/ReportQuestion';
import { StandardObject } from '../../../interfaces/api/CustomerReport';

export function isTreeTrimIssue(answers: ReportAnswers): boolean {
	// There's a tree on a wire
	let treeTrim = isAnswerValueSelected(answers, ReportQuestion.ObjectOnWire, StandardObject.Tree);
	if (treeTrim) {
		return true;
	}

	// There's a wire on a trree
	treeTrim = isAnswerValueSelected(answers, ReportQuestion.WireOnObject, StandardObject.Tree);
	if (treeTrim) {
		return true;
	}

	// There's tree debris
	treeTrim = isAnswerValueSelected(answers, ReportQuestion.Debris, [
		StandardObject.Tree,
		StandardObject.TreeTrunks,
		StandardObject.PiecesOfTree,
		StandardObject.BrushPickUp,
	]);
	if (treeTrim) {
		return true;
	}

	// There's some other type of issue involving a tree
	treeTrim = isAnswerValueSelected(answers, ReportQuestion.ProblemType, ProblemTypeQuestionValue.Tree);
	if (treeTrim) {
		return true;
	}

	return false;
}
